module.exports = __webpack_public_path__ + "files/3412b5ce6ea7b4a413f74307526ebb74.png";